import React from 'react';

export interface CardHeaderWithTitleProps extends React.HTMLProps<HTMLDivElement> {
  children?: React.ReactNode | React.ReactNode[];
  header?: never;
}

export interface CardHeaderWithCustomHeaderProps extends React.HTMLProps<HTMLDivElement> {
  children?: never;
  header?: React.ReactNode | React.ReactNode[];
}

const CardHeader: React.FC<CardHeaderWithTitleProps | CardHeaderWithCustomHeaderProps> = ({
  children,
  header,
  ...rest
}) => {
  return (
    <header className="zb-card-header" {...rest}>
      {header ?? <h2 className="zb-card-header-title">{children}</h2>}
    </header>
  );
};

export default CardHeader;
